<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [canGoBack]="true"
      [title]="'Request Substitute'" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>


    @if (!loaded && errorMessage) {
      <tidy-card>
        <tidy-row>
          <tidy-text
            [body]="errorMessage" />
        </tidy-row>
        @if (jobData) {
          <tidy-row class="extra-top-padding">
            <tidy-text
              [body]="'You can still book a new job for this address.'" />
          </tidy-row>
          <tidy-button
            [text]="'Book a New Job'"
            [action]="boundBookNewJob"
            class="primary" />
        }
      </tidy-card>
    }

    @if (loaded) {
      <tidy-row [align]="'center'">
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [body]="'Select times you\'re available, we\'ll notify all pros near you, and send updates.'" />
        </tidy-row>
        <tidy-row class="extra-bottom-padding">
          <tidy-text
            [helper]="'or'"
            class="divider" />
        </tidy-row>
        <tidy-row>
          <tidy-text
            [body]="'Select a confirmed time & we\'ll instantly book you with the available pro.'" />
        </tidy-row>
      </tidy-row>
      @for (weekday of substituteTimes; track weekday; let i = $index) {
        <tidy-card>
          <tidy-row>
            <tidy-text
              [header]="(weekday.date | parseDateTime: 'ddd') + ' ' + (weekday.date | parseDateTime: 'MMM d')" />
          </tidy-row>
          @for (time of weekday.times; track time; let dayIndex = $index) {
            <tidy-checkbox
              [items]="[{viewValue: (time.homekeepers.length > 0?
                (time.cleaning.start_time | parseDateTime: 'h:mma') + ' (confirmed)' :
                (time.cleaning.start_time | parseDateTime: 'h:mma')), value: true}]"
              [(ngModel)]="time.selected"
              (checkedChange)="selectTime(time, i, dayIndex)"
              [checked]="substituteTimes[i].times[dayIndex].selected"
              [initValue]="false" />
          }
        </tidy-card>
      }
      <tidy-row>
        <tidy-text
          [body]="'Click here'"
          (action)="bookNewJob()"
          class="link" /><span>&nbsp;</span>
          <tidy-text
            [body]="'to book later than'" /><span>&nbsp;</span>
            <tidy-text
              [body]="(substituteTimes[substituteTimes.length -1].date | parseDateTime: 'MMM d') + '.'" />
          </tidy-row>
          @if (errorMessage) {
            <tidy-row>
              <tidy-error-message
                [text]="errorMessage" />
            </tidy-row>
          }
          <tidy-button
            style="margin-bottom: 30px"
            [text]="'Review Request'"
            [action]="boundGoToConfirmRequest"
            class="primary" />
        }
      </tidy-wrapper>
    </ng-template>

    @if (!isRightSideContent) {
      <app-scroll-wrapper [templateContent]="content" />
    }

    @if (isRightSideContent) {
      <ion-content class="ion-content-right-column">
        <ng-container *ngTemplateOutlet="content" />
      </ion-content>
    }
